// extracted by mini-css-extract-plugin
export default {"row":"Row_row__FWHTb","placeHolderShimmer":"Row_placeHolderShimmer__-22Iv"};